export default "__VITE_ASSET__5ZTzqHnA__"